export const getCellData = (tableData, rowID, columnID) => {
  let row;
  if (Array.isArray(tableData)) {
    row = tableData[rowID];
  } else {
    row = Array.isArray(tableData.data) ? tableData.data[rowID] : [];
  }

  let currentValue;
  if (Array.isArray(row)) {
    currentValue = row[columnID];
  } else {
    const { data } = row;
    currentValue = data[columnID];
  }
  return currentValue;
};

export const updateCellData = (tableData, rowID, colID, cellValue) => {
  let currentValue = getCellData(tableData, rowID, colID);

  if (currentValue && currentValue instanceof Object) {
    const { attributes } = currentValue;
    if (attributes.editable !== false) currentValue.data = cellValue;
  } else {
    currentValue = cellValue;
  }
  const row = Array.isArray(tableData.data) ? tableData.data[rowID] : [];
  const { data } = row;
  data[colID] = currentValue;
  return tableData;
};

export const isTableActive = (section, activeID) => {
  const {
    data: { data: rowData },
    id,
  } = section;
  if (!Array.isArray(rowData)) return false;
  if (id === activeID) return true;
  for (let i = 0; i < rowData.length; i += 1) {
    const row = rowData[i];
    if (Array.isArray(row.data)) {
      for (let j = 0; j < row.data.length; j += 1) {
        const cell = row.data[j];
        if (cell.attributes.id === activeID) return true;
      }
    }
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/components/RevvTable/utils.js